import fetch from "auth/FetchInterceptor";
import axios from "axios";

const AuthService = {};

AuthService.login = function ({ data, language }) {
  return fetch({
    url: `${process.env.REACT_APP_API_ENDPOINT_URL}/v1/auth/signin`,
    method: "post",
    headers: {
      "public-request": "true",
      "Content-Type": "application/json",
      "accept-language": language,
    },
    data: data,
  });
};

AuthService.register = function (data) {
  return fetch({
    url: "/auth/register",
    method: "post",
    data: data,
  });
};

AuthService.signup = function (data, language) {
  return fetch({
    url: `${process.env.REACT_APP_API_ENDPOINT_URL}/v1/auth/signup`,
    method: "post",
    headers: {
      "public-request": "true",
      "Content-Type": "application/json",
      "accept-language": language,
    },
    data: data,
  });
};

AuthService.signup = function (data, language) {
  return fetch({
    url: `${process.env.REACT_APP_API_ENDPOINT_URL}/v1/auth/signup`,
    method: "post",
    headers: {
      "public-request": "true",
      "Content-Type": "application/json",
      "accept-language": language,
    },
    data: data,
  });
};

AuthService.gamepotSignup = function (data, language) {
  return fetch({
    url: `${process.env.REACT_APP_API_ENDPOINT_URL}/v1/auth/gamepot-signup`,
    method: "post",
    headers: {
      "public-request": "true",
      "Content-Type": "application/json",
      "accept-language": language,
    },
    data: data,
  });
};

AuthService.logout = function () {
  fetch({
    url: `${process.env.REACT_APP_API_ENDPOINT_URL}/v1/auth/signout`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      "accept-language": navigator.language,
    },
  });
};

AuthService.loginInOAuth = function () {
  return fetch({
    url: "/auth/loginInOAuth",
    method: "post",
  });
};

AuthService.forgotPassword = function (data) {
  return fetch({
    url: `${process.env.REACT_APP_API_ENDPOINT_URL}/v1/auth/forgot-password`,
    method: "post",
    headers: {
      "public-request": "true",
      "Content-Type": "application/json",
      "accept-language": navigator.language,
    },
    data: data,
  });
};

/**
 * 비밀번호 초기화 토큰 유효성 검사
 * @param {string} token - 비밀번호 초기화 토큰
 * @returns {Promise} 토큰 유효성 검사 결과
 */
export const verifyResetPasswordToken = (token) => {
  return axios.get(`${process.env.REACT_APP_API_ENDPOINT_URL}/v1/auth/token-reset-verify`, {
    params: { token }
  });
};

export default AuthService;
